export default __webpack_public_path__ + "static/media/sample02.d702cafb.jpg";